import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {compose} from 'redux';
import {createStructuredSelector} from 'reselect';
import {HBox} from '../../../components/Box';
import {Check, Times} from "../../../components/Icon";
import {BaseComponent} from "../../../components/BaseComponent";

const STATE = {};

class ConfirmBarComp extends BaseComponent {
    constructor(props) {
        super(props, {
            ...STATE,
        });
    }

    componentDidMount() {
    }

    render() {
        return (
            <HBox>
                <Check size={"2x"} onClick={this.props.apply}></Check>
                <Times size={"2x"} onClick={this.props.cancel}></Times>
            </HBox>
        );
    }
}

ConfirmBarComp.propTypes = {
    dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
    createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
    return {
        dispatch,
    };
}

const withConnect = connect(
    mapStateToProps,
    mapDispatchToProps,
);

export const ConfirmBar = compose(
    withConnect,
    withRouter,
)(ConfirmBarComp);
